import React, { useState, useEffect } from 'react';
import { updatePassword, signIn, signOut, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate, } from "react-router-dom";
import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";

function UpdatePassword() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();


    const gotoSuccess = (e) => {
        navigate('/landing');
    }

    async function handleUpdatePassword(e) {
        e.preventDefault();
        setLoading(true);
        try {
            if (newPassword === '' || oldPassword === '' || confirmPassword === '') {
                setLoading(false);
                toastr.warning('Preencha os campos obrigatórios');
                return;
            } else {
                if (confirmPassword.toString() !== newPassword.toString()) {
                    setLoading(false);
                    toastr.warning('A confirmação de senha é diferente da senha inserida');
                    return;
                } else {
                    await updatePassword({ oldPassword: oldPassword, newPassword: newPassword });
                    const { username } = await getCurrentUser();
                    if (username || username !== '') {
                        await getSession();
                        gotoSuccess();
                    } else {
                        await signOut();
                        localStorage.clear();
                        navigate('/');
                    }
                }
            }

        } catch (error) {
            setLoading(false);
            console.log(error);
            toastr.error('Ocorreu um erro ao solicitar alteração de senha');
            return;
        }
    }

    const getSession = async () => {
        const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
        const param = '&user_id=' + accessToken;
        const url = config.get('urlbase') + '/user/session?' + param;
        const headers = { 'x-api-key': config.get('apiKey') , 'Content-Type': 'application/json' };
        const userInfos = await axios.get(url, { headers });
        localStorage.setItem('userInfos', JSON.stringify(userInfos));
      }

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };
    const handlePasswordChange = (e) => {
        setOldPassword(e.target.value);
    };
    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };


    return (
        <div className='panel-login' style={{ height: "auto", paddingBottom: "25px", paddingTop: "25px" }}>
            <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='display--block margin--auto' alt='Logomarca' />
            <h1 className='title-login text-center' style={{ marginTop: "15px" }}>Insira a nova senha e confirme</h1>
            <Form onSubmit={handleUpdatePassword}>
                <Form.Group controlId="formPassword" className='group-input--big' style={{ marginTop: "15px" }}>
                    <Form.Label>Senha Atual*:</Form.Label>
                    <Form.Control type="password" value={oldPassword} onChange={handlePasswordChange} className='input--big' />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className='group-input--big' style={{ marginTop: "15px" }}>
                    <Form.Label>Nova Senha*:</Form.Label>
                    <Form.Control type="password" value={newPassword} onChange={handleNewPasswordChange} className='input--big' />
                </Form.Group>

                <Form.Group controlId="formBasicConfirmPassword" className='group-input--big' style={{ marginTop: "15px", marginBottom: "15px" }}>
                    <Form.Label>Confirmar Nova Senha*:</Form.Label>
                    <Form.Control type="password" value={confirmPassword} onChange={handleConfirmPasswordChange} className='input--big' />
                </Form.Group>

                {loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Button variant="primary" type="submit" className='margin--auto display--block' style={{ marginBottom: "30px" }}>
                        Alterar
                    </Button>
                }

                <span>
                    <b>A senha deve conter:</b><br />- pelo menos, 6 caracteres e, no máximo, 99 caracteres.<br />- 1 caractere especial dos seguintes: ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ <br />- Letra maiúscula<br />- Letra minúscula
                </span>
            </Form>
        </div>
    );
};

export default UpdatePassword;
